'use strict';

module.exports = {
  processRequest: function(req) {
    req.url = req.url.replace(/[^%]+/g, function(s) {
      return encodeURI(s);
    });
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/httpplease/plugins/cleanurl.js
// module id = 816
// module chunks = 4